










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
	@Prop({ required: true, type: String }) id!: string;

	public $refs!: {
		modal: any;
	};

	public hide() {
	    this.$refs.modal.hide();
	}

	public show() {
	    this.$refs.modal.show();
	}
}
